import HttpService from '~/services/httpService';

const get = HttpService.get;

export async function showCustomerPortfolio(companyDocument: string, params?: any) {
  return await get('customers-portfolio', { params: { ...params, companyDocument } }).then(
    (response) => response.data.data,
    (error) => {
      throw error;
    },
  );
}
